// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".fees-for-security-master-form .el-form--inline[data-v-8d40611c] {\n  display: flex;\n  justify-content: space-between;\n}\n.fees-for-security-master-form .el-form-item[data-v-8d40611c] {\n  width: 60em;\n}\n.fees-for-security-master-form .parent_Box[data-v-8d40611c] {\n  padding-right: 15px;\n}", ""]);
// Exports
module.exports = exports;
